import { styled } from "@mui/material";

export const ShipperSelectStyle = styled("div")(() => ({
  fontFamily: "Manrope",
  color: "#475467",
  display: "flex",
  flexDirection: "column",
  "& > span:nth-child(1)": {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    letterSpacing: "0.25px",
  },
  "& > span:nth-child(2)": {
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: "0.5px",
  },
}));
